export default class ChangePasswordDto {
	public newPassword = '';
	public originalPassword = '';
	public verificationToken = '';

	public constructor(init?: Partial<ChangePasswordDto>) {
        Object.assign(this, init);
    }
}